import { useQuery } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

// GET /sales/requests/today — the "Today" daily task list (this task's
// brief): unpriced-over-threshold, rejected-needing-repricing,
// expiring-soon, and near-needed-by, all scoped to this salesperson. See
// services/requestService.js#getTodayForSalesUser for the exact shape:
// { unpriced, rejectedNeedingReprice, expiringSoon, neededBySoon,
//   thresholds: { unpricedHours, expiryDays, neededByDays } }.
export function useToday() {
  return useQuery({
    queryKey: ['sales', 'today'],
    queryFn: () => apiClient.get('/sales/requests/today'),
  });
}

export default useToday;
